import React from 'react';

import { GridContainer, Column, Row, Divider } from '@vp/swan';
import { useSelector } from 'react-redux';

import { cartSelectors } from '../../state/cart';
import { PendingItemSummary } from './PendingItemSummary';

export const PendingItemSummaries = () => {
  const pendingItemSummaries = useSelector(state =>
    cartSelectors.selectPendingItemSummaries(state.cart)
  );

  if (!pendingItemSummaries || pendingItemSummaries.length === 0) {
    return null;
  }

  return (
    <GridContainer>
      <Row>
        <Column span={12}>
          <Divider marginY={4} />
        </Column>
      </Row>
      {pendingItemSummaries.map((pendingItemSummary, index) => (
        <>
          <Row key={index}>
            <Column span={12}>
              <PendingItemSummary pendingItemSummary={pendingItemSummary} />
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <Divider marginY={4} />
            </Column>
          </Row>
        </>
      ))}
    </GridContainer>
  );
};
